module.exports = __webpack_public_path__ + "img/btn_bottom_njdd.3d4da02b.png";